import { useEffect, useState } from 'react';
import { consentCategoryMeasurementGiven } from '@/app/common/utils/consentCategoryMeasurementGiven';

const POLLING_INTERVAL_MS = 500;

const useCookieConsent = (isLocal?: boolean): boolean => {
  const commonData = isLocal != null ? { isLocal } : undefined;
  const [hasConsent, setHasConsent] = useState<boolean>(() => consentCategoryMeasurementGiven(commonData));

  useEffect(() => {
    if (hasConsent) return undefined;

    const interval = setInterval(() => {
      if (consentCategoryMeasurementGiven(commonData)) {
        setHasConsent(true);
        clearInterval(interval);
      }
    }, POLLING_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [hasConsent]);

  return hasConsent;
};

export default useCookieConsent;
